import { api } from '../../lib/api';

export interface CreditNoteDTO {
  id: number;
  number: string;
  invoiceId: number;
  reason: string;
  status: 'DRAFT' | 'ISSUED' | 'DIAN_PENDING' | 'DIAN_APPROVED' | 'DIAN_REJECTED';
  cufe: string | null;
  subtotal: string;
  taxTotal: string;
  total: string;
  issuedAt: string;
  invoice: {
    id: number;
    number: string;
    customer: { firstName: string; lastName: string };
  };
}

export async function listCreditNotes(): Promise<CreditNoteDTO[]> {
  const { data } = await api.get<CreditNoteDTO[]>('/api/credit-notes');
  return data;
}

export interface IssueResult {
  creditNoteId: number;
  number: string;
  cufe: string;
  status: string;
  reverseJournalEntryId: number;
  stockRestored: number;
}

export async function issueCreditNote(invoiceId: number, reason: string): Promise<IssueResult> {
  const { data } = await api.post<IssueResult>('/api/credit-notes/issue', { invoiceId, reason });
  return data;
}

export function creditNotePdfUrl(creditNoteId: number): string {
  return `/api/credit-notes/${creditNoteId}/pdf`;
}
